import Vue from 'Vue';
import _ from 'lodash';
import {instance as dataService} from '../../services/data.service';
import dcUtilities from '../../utilities/dc.utility';

/**
 * ********************************************************************
 * standard import lines for every component. Importing the template
 * and the component specific style.
 * ********************************************************************
 */
import './dc-list.style.scss';
import template from './dc-list.template.htm';
import settings from "../../settings/settings";

/**
 * *********************************************************************
 */

export default Vue.component('dc-list', {
    template: template,
    props: {
        locale: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            distance: 300,
            spinner: "waveDots",
            firstPageLoaded: false
        };
    },
    computed: {
        data() {
            let res = _.map(this.$store.getters.contents.data, element => {
                element.details = element.details || [{}];
                element.details[0].description = element.details[0].description || "";
                element.details[0].image = element.details[0].image || [{}];
                element.details[0].image[0].thumbnailUrl = element.details[0].image[0].thumbnailUrl || settings.defaults.thumbnail;
                return element;
            });
            return res;
        },
        initialItems(){
            return _.map(this.$store.getters.initialFeaturesList, element => {
                element.details = element.details || [{}];
                element.details[0].description = element.details[0].description || "";
                element.details[0].image = element.details[0].image || [{}];
                element.details[0].image[0].thumbnailUrl = element.details[0].image[0].thumbnailUrl || settings.defaults.thumbnail;
                return dcUtilities.convertTripToTile(element, this.locale);
            });
        },
        isInitialListEmpty(){
          return this.initialItems.length <= 0;
        },
        items() {
            return _.map(this.data, item => {
                return dcUtilities.convertTripToTile(item, this.locale);
            });
        },
        contents() {
            return this.$store.getters.contents;
        },
        isLoading: {
            get() {
                return this.$store.getters.isLoading;
            },
            set(newValue) {
                this.$store.commit('setIsLoading', newValue);
            }
        },
        activeTrip() {
            return this.$store.getters.activeTrip;
        },
        filters() {
            return this.$store.getters.filters;
        }
    },
    watch: {
        filters:{
            deep: true,
            handler() {
                this.contents.page = 1;
                this.contents.data = [];
                this.$store.commit('setInitialFeaturesList', []);
                this.$nextTick(() => {
                    this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset');
                });
            }
        }
    },
    created() {
    },
    mounted() {
    },
    methods: {
        onInfinite() {
            const metaPages = _.get(this.contents, 'meta.pages', 0) || 1;
            if (this.contents.meta && _.get(this.contents, 'page', 0) > metaPages) {
                this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete');
                return;
            }

            this.isLoading = true;
            dataService.load({
                page: this.contents.page,
                categories: this.filters.categories,
                query: this.filters.keyword
            })
                .then(result => {
                    this.contents.page++;
                    this.contents.data = this.contents.data.concat(
                        result.data.filter((item) => {
                            const tripId = _.get(item, '@id');
                           return this.initialItems.filter(i => {
                               return i.id == tripId;
                           }).length == 0;
                        })
                    );
                    this.contents.meta = result.meta;
                    this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded');
                    this.$emit('loaded');
                    if (this.contents.page == this.contents.meta.pages) {
                        this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete');
                        //this.contents.page = 1;
                    }
                    this.isLoading = false;
                    if(!this.firstPageLoaded){
                        this.firstPageLoaded = true;
                        if(this.initialItems.length == 1){
                            setTimeout(() => {
                                this.$store.commit('setActiveTrip', this.initialItems[0]);
                            },100);
                        }
                    }

                    if(!!this.filters.keyword) {
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            'event': 'user action',
                            'gaEventCategory': 'karte suche',			// keine VAR, ist fest vergeben
                            'gaEventAction': this.filters.keyword,  	// VAR =  Suchbegriff Nutzer
                            'gaEventLabel': this.contents.meta.total,	// VAR = Anzahl Ergebnisse
                            'gaEventValue': '1',						// Fest =  1
                        });
                    }
                    if(!!this.filters.categories && this.filters.categories.length > 0) {
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            'event': 'user action',
                            'gaEventCategory': 'karte filter',			   // keine VAR, ist fest vergeben
                            'gaEventAction': this.filters.categories.map(category => { return category.name; }).join(','),  					// VAR =  Auswahl des Nutzers <- "Rad und Schiff" getrennt mit Komma
                            'gaEventLabel': this.contents.meta.total,    // VAR = Anzahl Ergebnisse
                            'gaEventValue': '1',						// Fest =  1
                        });
                    }

                })
                .catch(error => {
                    if (error.response) {
                        alert(error.response.status + ' ' + error.response.statusText + '\n' + error.response.data.error);
                    } else if (error.request) {
                        console.log(error.request);
                    } else {
                        console.log('Error', error.message);
                    }
                    console.log(error.config);
                    this.isLoading = false;
                });
        },
        async cardClicked(item) {

            let tour = _.get(item, 'original.details[0].tour', null);
            if(!tour){
                return;
            }

            this.$store.commit('setActiveTrip', item);
            /*
            let trip = await dataService.loadSingleV4(item['@id']);
            console.log(trip);
            this.$store.commit('setActiveTrip', trip);
            this.$store.commit('setDetailViewOpen', true);
            //*/
        }
    }
});